<template>
  <div :class="['tabs_bar', props.tabsClass]">
    <Tabs
      v-model:active="activeName"
      @change="onChange"
      :color="themeColor"
      :ellipsis="false"
      :shrink="isShrink"
      :border="border"
    >
      <Tab
        v-for="(item, index) in props.tabDate"
        :key="index"
        :title="isTranslation ? $t(item.title) : item.title"
        :name="item.name"
        :badge="item.badge"
      />
    </Tabs>
    <DropdownMenu
      v-if="props.statusDate"
      active-color="themeColor"
      :class="
        isFeishu || isWechat || isApp || isSandsTalkFlutterApp || isSandsTalkNativeApp || isSandsTalkPhOutfieldApp || isSandsTalkMSFlutterApp
          ? 'custom-dropdown-menu-other'
          : 'custom-dropdown-menu'
      "
    >
      <DropdownItem v-model="defaultIndex" :options="props.statusDate" @change="changeStatus" />
    </DropdownMenu>
  </div>
</template>

<script setup lang="ts">
import { onMounted, PropType, ref, watch } from 'vue'
import { Tab, Tabs, DropdownMenu, DropdownItem } from 'vant'
import { useThemeColor } from '@/utils/theme'
import { isFeishu } from '@/utils/feishu'
import { isWechat } from '@/utils/weixin'
import { isApp } from '@/utils/client'
import { isSandsTalkFlutterApp } from '@/utils/sandsTalkFlutter'
import { isSandsTalkMSFlutterApp } from '@/utils/sandsTalkMSFlutter'
import { isSandsTalkNativeApp } from '@/utils/sandsTalkNative'
import { isSandsTalkPhOutfieldApp } from '@/utils/sandsTalkPhOutfiled'

type TabDateOption = {
  title: string
  name: number | string
  badge?: number
}

type StatusOption = {
  text: string
  value: number
}

const props = defineProps({
  tabDate: {
    type: Array as PropType<TabDateOption[]>
  },
  statusDate: {
    type: Array as PropType<StatusOption[]>
  },
  activeDate: {
    type: Number
  },
  isTranslation: {
    type: Boolean,
    default: true
  },
  isShrink: {
    // 是否开启收缩模式
    type: Boolean,
    default: false
  },
  tabsClass: {
    // 添加class名字
    type: String,
    default: ''
  },
  isThemeColor: {
    type: Boolean,
    default: true
  },
  defaultStatusIndex: {
    // 改变下拉框的默认值
    type: Number,
    default: 0
  },
  border: {
    type: Boolean,
    default: false
  }
})

const defaultIndex = ref<number>(props.defaultStatusIndex)
const activeName = ref(props.activeDate || 0)
const themeColor = props.isThemeColor ? useThemeColor() : 'white'
const emit = defineEmits(['upTab', 'upStatus'])

const onChange = (name: string) => {
  emit('upTab', name)
}

const changeStatus = async (value: number) => {
  defaultIndex.value = value
  emit('upStatus', defaultIndex.value)
}

watch(
  () => props.activeDate,
  (newData) => {
    activeName.value = newData as number
  }
)

watch(
  () => props.defaultStatusIndex,
  (newValue) => {
    defaultIndex.value = newValue
  }
)
onMounted(() => {
  if (props.statusDate && props.statusDate.length > 0) {
    props.statusDate.forEach((e, index) => {
      if (index === defaultIndex.value) {
        // defaultName.value = e.title
        emit('upStatus', defaultIndex.value)
      }
    })
  }
})
</script>

<style lang="less">
.tabs_flex {
  .van-dropdown-menu {
    margin-right: 10px;
    background: #fff;
    z-index: 999;
    .van-dropdown-menu__bar {
      position: absolute;
      right: 0;
      height: 44px;
      // box-shadow: none;
    }
  }
}
</style>

<style scoped lang="less">
.custom-dropdown-menu {
  position: absolute;
  z-index: 999;
  top: 42px;
  right: -10px;
  display: flex;
  background: #fff;
}
.custom-dropdown-menu-other {
  position: absolute;
  z-index: 999;
  top: 0;
  right: -10px;
  display: flex;
  background: #fff;
}

.tabs_flex {
  display: flex;
  :deep(.van-tabs) {
    flex: 1;
  }
}
.tabs_bar {
  width: 100%;
  background-color: #ffffff;
  :deep(.van-tab) {
    font-size: 15px;
    color: #61666d;
  }
  :deep(.van-tab--active) {
    color: #171921;
  }
}
.cancel_div {
  width: 100px;
  padding: 12px;
  .cancel_text {
    font-size: 14px;
    padding-top: 18px;
  }
  .cancel_text:nth-child(1) {
    padding-top: 0;
  }
}
.cancel_default {
  font-size: 14px;
  margin-right: 16px;
  color: #171921;
  .cancel_arrow {
    margin-left: 4px;
  }
}
.default_color {
  color: v-bind(themeColor);
}
:deep(.van-dropdown-menu__title) {
  font-size: 13px;
  margin-right: 12px;
}
:deep(.van-dropdown-menu__title:after) {
  right: 0px;
}
:deep(.van-dropdown-menu__item) {
  max-width: 120px;
}
</style>
